import { Checkbox, Form } from "antd";
import React, { useEffect, useState } from "react";
import { cardioPastMedicalOptions } from "../OpPhysioOptions";
import DynamicInputFields from "../../../../../blocks/FormItems/DynamicInputFields";

const PastMedicalOP = ({ form, onSync }) => {
  const [showRemarks, setShowRemarks] = useState(false);
  useEffect(() => {
    const values = form.getFieldValue("past_medical_history") || [];
    setShowRemarks(values.includes("past_medical_others"));
  }, [form]);

  const handleChange = (checkedValues) => {
    const filtered = checkedValues.map((v) =>
      typeof v === "string" ? v : v.value || v
    );

    setShowRemarks(filtered.includes("past_medical_others"));

    if (!filtered.includes("past_medical_others")) {
      form.setFieldValue("past_medical_comments", []);
    } else {
      const existing = form.getFieldValue("past_medical_comments");
      if (!Array.isArray(existing) || existing.length === 0) {
        form.setFieldValue("past_medical_comments", [{ remarks: "" }]);
      }
    }

    form.setFieldValue("past_medical_history", filtered);
    onSync?.();
  };

  return (
    <>
      <Form.Item label="Past Medical History" name="past_medical_history">
        <Checkbox.Group
          options={cardioPastMedicalOptions}
          onChange={handleChange}
        />
      </Form.Item>

      {showRemarks && (
        <DynamicInputFields
          form={form}
          field_key="past_medical_comments"
          inputStyle={{ width: "60%" }}
          formStyle={{ marginBottom: 0 }}
        />
      )}
    </>
  );
};

export default PastMedicalOP;
